import { ISubmissionResponse } from "../../../app/modules/submissions/ISubmissionResponse";

export const SUBMISSIONS_CONSTANTS = {
    RESET: "RESET",
    FETCH_LOADING: "FETCH_LOADING",
    STOP_FETCH: "STOP_FETCH",
    FETCH_ALL: "FETCH_ALL",
    FETCH_DETAILS: "FETCH_DETAILS",
    REQUEST_REFRESH: "REQUEST_REFRESH",
}

export interface IVerificationState {
    loading: boolean
    all?: ISubmissionResponse[] | undefined
    selected?: ISubmissionResponse | undefined
    refreshKey: number
}

const initialState: IVerificationState = {
    loading: false,
    all: [],
    selected: undefined,
    refreshKey: 0,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case SUBMISSIONS_CONSTANTS.FETCH_LOADING: {
            return {...state, loading: action.payload}
        }
        case SUBMISSIONS_CONSTANTS.STOP_FETCH: {
            return {...state, loading: false}
        }
        case SUBMISSIONS_CONSTANTS.FETCH_DETAILS: {
            return {...state, selected: action.payload}
        }
        case SUBMISSIONS_CONSTANTS.FETCH_ALL: {
            return {...state, all: action.payload, selected: undefined}
        }
        case SUBMISSIONS_CONSTANTS.RESET: {
            return {...state, all: [], selected: undefined, loading: false}
        }
        case SUBMISSIONS_CONSTANTS.REQUEST_REFRESH: {
            return {...state, refreshKey: state.refreshKey + 1}
        }
        default: {
            return state
        }
    }
}